import useResizeObserver from "@react-hook/resize-observer";
import { useLayoutEffect, useState } from "react";

/** The rail carries this class in `ActivityBar.tsx`. */
const ACTIVITY_BAR_SELECTOR = ".activity-bar";

/**
 * Where the application's left chrome ends, in px from the left of the window,
 * or null when there is no rail to measure.
 *
 * Measured rather than taken from `--activity-bar-width`, which holds only the
 * collapsed width: the rail is far wider whenever one of its panes is open,
 * and a card laid out against the collapsed figure starts underneath that
 * pane. The rail is also OBSERVED, so opening or closing a pane re-flows the
 * card instead of leaving it where the last render put it.
 */
export function useChromeInsetLeft(): Maybe<number> {
  const [rail, setRail] = useState<Maybe<HTMLElement>>(null);
  const [insetLeft, setInsetLeft] = useState<Maybe<number>>(null);

  // The rail is mounted by the shell, above and outside this card, so it is
  // found rather than passed in.
  useLayoutEffect(() => {
    const found = document.querySelector<HTMLElement>(ACTIVITY_BAR_SELECTOR);
    setRail(found);
    if (found) setInsetLeft(found.getBoundingClientRect().right);
  }, []);

  useResizeObserver(rail ?? null, (entry) => {
    setInsetLeft(entry.target.getBoundingClientRect().right);
  });

  return insetLeft;
}
